import React, { useState } from 'react';
import './messengerInput.css';
import Button from '../../../components/UI/Button/Button';
import axiosInstance from '../../../utils/router/axiosInstance';
import { useMessageContext } from '../../../context/MessageContext';
import { logger } from '../../../utils/logger';
const MessengerInput = ({ id }) => {
    const [message, setMessage] = useState('');
    const { toggleUpdateMessages } = useMessageContext();

    const handleMessageChange = (e) => {
        setMessage(e.target.value);
    };

    const handleSendPostRequest = () => {
        if (message.trim() === '') {
            logger.debug('Message is empty. Cannot send.');
            return;
        }
    
        const requestBody = {
            message: message,
            status: false,
            is_user_sender: false
        };
    
        axiosInstance.post(`chat/owner_dialog/${id}`, requestBody)
            .then(response => {
                logger.debug('Message sent successfully');
                setMessage('');
                toggleUpdateMessages(); // Обновление сообщений в MessageList
            })
            .catch(error => {
                logger.error('Error sending message:', error);
            });
    };
    

    const inputStyle = {
        height: Math.min(200, Math.max(40, message.split('\n').length * 20)) + 'px',
    };

    return (
        <div className="messenger-input-container">
            <div className="messenger-input-wrapper">
                <textarea
                    className="messenger-input"
                    style={inputStyle}
                    value={message}
                    onChange={handleMessageChange}
                    placeholder="Введите ваше сообщение..."
                />
                <Button className="send-button" onClick={handleSendPostRequest} text=">" />
            </div>
        </div>
    );
};

export default MessengerInput;
